import { usePreferencesStore } from '@/core/store/preferences.store';

import type { Locale } from '../../../i18n-config';

/**
 * Hook that gets the current locale from Zustand preferences store.
 * The locale is persisted and initialized from browser preferences on first load.
 *
 * @returns The current locale
 */
export function useLocale(): Locale {
  return usePreferencesStore((state) => state.locale);
}
